/**
 *
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PortalGlobalNotificationsResponse {
  id?: string;
  description?: string | null;
  createdDate?: string;
  isEnabled?: boolean;
  createdBy?: string;
}
